import { render } from "./providerType.vue?vue&type=template&id=ff47023a"
import script from "./providerType.vue?vue&type=script&lang=js"
export * from "./providerType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__